

import { ApiTwoTone, BulbTwoTone, RocketTwoTone,  } from '@ant-design/icons';
import { Modal, Divider, Row, Progress, Drawer, Card,   } from 'antd';
import Meta from 'antd/es/card/Meta';
import * as React from 'react';
import { L } from '../../../../lib/abpUtility';
import { Progress as Progress2 } from '@ant-design/plots';

export interface IOurStoryProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    isMobile: boolean;
    location: any;
    onCancel: () => void;
    onLogin: (values: any) => void;
}

export interface IOurStoryState {
    loading: boolean;
    modalDrawerVisible: boolean;
    subDrawerVisible: boolean;
    currentInfoEmail: string;
    currentInfoName: string;
    currentInfoImage: string;
    currentInfoText: string;
    currentInfoTitle: string;
}

class OurStory extends React.Component<IOurStoryProps, IOurStoryState> {
    state = {
        loading: false,
        modalDrawerVisible: false,
        subDrawerVisible: false,
        currentInfoName: '',
        currentInfoImage: '',
        currentInfoText: '',
        currentInfoTitle: '',
        currentInfoEmail: ''
    };



    render() {
        const { visible, isMobile, onCancel } = this.props;
        const headerConfig = {
            percent: 1,
            color: [this.props.secondaryColor, this.props.primaryColor],
        };
        const headerConfig2 = {
            percent: 1,
            color: [this.props.primaryColor, this.props.secondaryColor],
        };
        return (

            <div className="font-face-gm">

                <div>
                    <Modal
                        closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        footer={null}
                        onCancel={onCancel}
                        width={730}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Who We Are')}
                        </Divider>
                        <Row style={{ marginBottom: '0px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>
                        <Card hoverable={true} title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{}}>
                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'About TBTLA'}</div>}
                                    description={L('TBTLA is a non-profit organization whose membership is limited to current and former technology executives. Our two-fold mission is to apply the collective experience of the membership to real-world technology problems, and to mentor students – and other professionals – who are anticipating careers in information technology.')}  />

                            </Card>
<br />
                        <Card bordered={false} style={{ paddingTop: '0px', marginTop: '0px' }}>
                            <Card hoverable={true}  cover={

                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig2} /></div>
                            } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ width: '48%', float: 'right', height: '185px' }}>
                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.3em', height: '25px', }}>{'Our Focus'}</div>}
                                    description={L('To bring education, leadership, and connections together in order to provide the skills needed to advance in technology leadership.')} />

                            </Card>
                            <Card hoverable={true} cover={

                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig2} /></div>
                            } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ width: '48%', height: '185px' }}>

                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.3em', height: '25px', }}>{'Our Vision'}</div>}
                                    description={L('To foster relationships, build programs, and organize related events for local students, professionals, and leaders in the Tampa Bay technology community.')} />
                            </Card>


                            <Divider style={{ fontSize: '1.5em', fontWeight: 'bold', marginTop: '35px' }}>{L('Program Areas')}</Divider>

                            <br />
                            <Card hoverable={true}cover={

                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>
                            } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ height: '110px' }}>

                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'GETSMART'}</div>}
                                    avatar={<BulbTwoTone style={{ fontSize: '2.1em', height: '110px' }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                    description={'Focuses on K-12 students; providing opportunity to discover and learn about technology.'} />
                            </Card> <br /> <Card hoverable={true} cover={

                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>
                            } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ height: '110px' }}>

                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'GETHIRED'}</div>}
                                    avatar={<ApiTwoTone style={{ fontSize: '2.1em', height: '110px' }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                    description={'Focuses on University/Trade technology students: providing mentorship, internship, job fair, and network opportunities with companies in Tampa Bay.'} />
                            </Card><br /> <Card hoverable={true}  cover={

                                <div style={{ height: '35px', overflow: 'hidden', opacity: '1', marginBottom: '-35px' }}>
                                    <Progress2 height={25} autoFit={true} style={{ marginTop: '-12px', width: '100%' }} {...headerConfig} /></div>
                            } title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ height: '110px' }}>
                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'GETAHEAD'}</div>}
                                    avatar={<RocketTwoTone style={{ fontSize: '2.1em', height: '110px' }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                    description={'Focuses on technology professionals and emerging leaders; providing engagements on how to develop and get ahead in your career.'} />
                            </Card>
                           
                        </Card>

                    </Modal>
                </div>

                <div>
                    <Drawer
                        closable={this.props.isMobile === true ? true : false}
                        onClose={onCancel}
                        visible={isMobile === true ? (visible === true ? true : false) : false}
                        footer={null}
                        width={isMobile === true ? (window.innerWidth * 0.9) : 420}
                        title={null}>
                       <Divider className="font-face-gm" type="horizontal" style={{ fontSize: this.props.isMobile === true ? '2em' : '2.3em', marginBottom: '0px' }} >
                            {L('Who We Are')}
                        </Divider>

                        <Row style={{ marginBottom: '20px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>  <Card bordered={false} style={{ paddingTop: '0px', marginTop: '-10px' }}>
                        <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{}}>
                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'About TBTLA'}</div>}
                                    description={L('TBTLA is a non-profit organization whose membership is limited to current and former technology executives. Our two-fold mission is to apply the collective experience of the membership to real-world technology problems, and to mentor students – and other professionals – who are anticipating careers in information technology.')}  />

                            </Card>
                            <br />
                       
                            <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ height: '185px' }}>
                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Our Focus'}</div>}
                                    description={L('To bring education, leadership, and connections together in order to provide the skills needed to advance in technology leadership.')} />

                            </Card><br />
                            <Card title={''} bordered={true} headStyle={{ textAlign: 'center', fontSize: '1.5em', fontWeight: 'bold', }}
                                style={{ height: '185px' }}>

                                <Meta className="font-face-gm"
                                    title={<div style={{ fontSize: '1.1em', height: '25px', }}>{'Our Vision'}</div>}
                                    description={L('To foster relationships, build programs, and organize related events for local students, professionals, and leaders in the Tampa Bay technology community.')} />
                            </Card>


                            <Divider style={{ fontSize: '1.5em', fontWeight: 'bold', marginTop: '35px' }}>{L('Program Areas')}</Divider>

                            <br />
                            <Meta className="font-face-gm"
                                title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'GETSMART'}</div>}
                                avatar={<BulbTwoTone style={{ fontSize: '2.1em', height: '110px' }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                description={'Focuses on K-12 students; providing opportunity to discover and learn about technology.'} />
                            <br /> <br />
                            <Meta className="font-face-gm"
                                title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'GETHIRED'}</div>}
                                avatar={<ApiTwoTone style={{ fontSize: '2.1em', height: '110px' }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                description={'Focuses on University/Trade technology students: providing mentorship, internship, job fair, and network opportunities with companies in Tampa Bay.'} />
                            <br /> <br />
                            <Meta className="font-face-gm"
                                title={<div style={{ fontSize: '1.5em', height: '30px', }}>{'GETAHEAD'}</div>}
                                avatar={<RocketTwoTone style={{ fontSize: '2.1em', height: '110px' }} twoToneColor={[this.props.primaryColor, '#f1f2f5']} />}
                                description={'Focuses on technology professionals and emerging leaders; providing engagements on how to develop and get ahead in your career.'} />

                            
                        </Card>


                    </Drawer>
                </div>

            </div>
        );
    }

}

export default OurStory;